import Artikelzeile from "./Artikelzeile";
import React from "react";

export default function ArtikelVorlage({positions}) {

    const handler =  (idx) => {
        document.getElementById(idx).remove();
    }

    return (<>
        {positions.map(position => {return <Artikelzeile values={position} key={'v' + position.id} handler={() => {handler('v' + position.id)}} idx={'v' + position.id}/>})}
    </>);
}